import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useContext, useEffect } from "react";

import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import { SidebarContext } from "context/SidebarContext";
import { FiPlus } from "react-icons/fi";
import Loader from "components/form/Loader";
import sidebar from "routes/sidebar";
import Somethingwentwrong from "pages/Somethingwentwrong";
import { FiRefreshCcw } from "react-icons/fi";
import FranchiseTable from "components/Franchise/FranchiseTable";
import FranchisePageServices from "services/FranchiseService";
import FranchiseDrawer from "components/drawer/FranchiseDrawer";
import MainDrawer from "components/drawer/MainDrawer";

const Franchise = () => {
  const [tab, setTab] = useState("");
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  // const {
  //   state: { adminInfo },
  // } = useContext(AdminContext);

const { data, loading, error } = useAsync(
  () =>
    FranchisePageServices.getAllFranchisePage({
      type: tab,
    }),
  [tab]
);

  const [status, setStatus] = useState("");
  const { toggleDrawer, functionLoading, setIsUpdate } =
    useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [itemsPerPage, setItemsPerPage] = useState(100);
  let safedata = Array.isArray(data?.data) ? data?.data : [];
  const {
    franchiseRef,
    dataTable,
    serviceData,
    handleSubmitFranchise,
    currentPage,
  } = useFilter(safedata, itemsPerPage);
  useEffect(() => {
    if (safedata.length !== 0) {
      setItemsPerPage(safedata.length);
    }
  }, [safedata]);
  const isAdmin = adminInfo?.id === 1;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "franchise" && perm.view === 1,
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "franchise" && perm.delete === 1,
      );

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "franchise" && perm.edit === 1,
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "franchise" && perm.add === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "franchise" && perm.export === 1,
      );

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  const updatedData = dataTable?.map((item, index) => ({
    "SI.No": index + 1 ||'-',
    "Reference No": item.reference_no||'-',
    "Company Name": item.company_name ||'-',
    "Owner Name": item.owner_name ||'-',
    Email: item.email_id ||'-',
    "Phone Number": item.phone_no ||'-',
    Address: item.address ||'-',
    Pincode: item.pincode ||'-', 
    State: item.state?.name ||'-',
    City: item.city?.name,
    "Service States": item.service_states?.map((x) => x.name).join(", "),
    "Service Cities": item.service_cities?.map((x) => x.name).join(", "),
    Status: item.status ||'-',
    "Account Status": item.account_status ||'-',
    "PAN Number": item.pan_number ||'-',
    "GST Number": item.gst_number ||'-',
    "Bank Name": item.bank_name ||'-',
    "Account Number": item.account_number ||'-',
    "Beneficiary Name": item.beneficiary_name ||'-' ,
    "IFSC Code": item.ifsc_code||'-',
    // "Created At": item.created_at,
    // "Updated At": item.updated_at,
  }));
  const [isOpen, setIsOpen] = useState(false);
  const handleRefresh = () => {
    setIsUpdate(true);
  };
  const handleSuccessModalOpen = () => {
    setIsOpen(true);
  };

  const handleSuccessModalClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />
          <MainDrawer>
            <FranchiseDrawer
              id={serviceId}
              onModalOpen={handleSuccessModalOpen}
            />
          </MainDrawer>
          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex gap-6 items-center">
                <div className="flex-1">
                  <Input
                    ref={franchiseRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSubmitFranchise}
                  />
                </div>

                {hideAdd && (
                  <div className="w-56">
                    <Button
                      onClick={toggleDrawer}
                      className="w-full rounded-md h-10"
                    >
                      <span className="mr-3">
                        <FiPlus />
                      </span>
                      Add Franchise
                    </Button>
                  </div>
                )}

                {hideExport && (
                  <div className="items-center">
                    <ExportDataXlsx
                      title="Franchise"
                      id_employee={adminInfo.id}
                      exportDataXlsx={updatedData}
                      fileNames="franchise List"
                    />
                  </div>
                )}

                <FiRefreshCcw
                  onClick={() => {
                    handleRefresh();
                  }}
                  cursor="pointer"
                />
              </div>
            </CardBody>
          </Card>
          {functionLoading && <Loader message="Please wait..." />}
          <DataWrapper loading={loading} error={error} status={status}>
            <div className="flex gap-6 mb-4 border-b pb-2">
            

              <p
                onClick={() => setTab(1)}
                className={`cursor-pointer pb-2 ${
                  tab === 1
                  ? "text-green-600 border-b-2 border-green-600 font-semibold"
                    : "text-gray-500"
                }`}
              >
                Awaiting / Rejected
              </p>

              <p
                onClick={() => setTab(2)}
                className={`cursor-pointer pb-2 ${
                  tab === 2
                    ? "text-green-600 border-b-2 border-green-600 font-semibold"
                    : "text-gray-500"
                }`}
              >
                Approved 
              </p>

                <p
                onClick={() => setTab("")}
                className={`cursor-pointer pb-2 ${
                  tab === ""
                    ? "text-green-600 border-b-2 border-green-600 font-semibold"
                    : "text-gray-500"
                }`}
              >
                All
              </p>
            </div>
            {serviceData?.length !== 0 ? (
              <TableContainer className="mb-8">
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "67vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                      <tr>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Company Name</TableCell>
                        <TableCell>Owner Name </TableCell>
                        <TableCell>City</TableCell>
                        <TableCell>State</TableCell>
                        <TableCell>Email Address </TableCell>
                        <TableCell>Contact No </TableCell>
                        <TableCell>Status </TableCell>
                        <TableCell>Changes</TableCell>
                        <TableCell>Approval</TableCell>
                        <TableCell className="text-center">Actions</TableCell>
                      </tr>
                    </TableHeader>
                    <FranchiseTable
                      setIsUpdate ={handleRefresh}
                      franchise={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                      tab={tab}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {data.status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Franchise." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default Franchise;
